import { JSONEditor } from "react-json-editor-viewer";
import { Card } from "../../components/Card"
import { CheckBox, Input, Label, TextArea } from '../../components/Form';
import { Button, ButtonActions, ButtonLoader } from '../../components/Button';
import { LinkOrUpload } from '../../components/LinkOrUpload';
import { isValidURL } from '../../core/utils/validateFields';

import './styles.scss';
import ModalAlert from "../../components/ModalAlert";

export const NewDashboardScreen = ({
  onChangeInput,
  values,
  handleSubmit,
  toggleScreen,
  errors,
  register,
  onChangeImage,
  uploadedImage,
  loading,
  hasJsonConfig,
  toggleJsonConfig,
  selectedDashId,
  handleRemoveDash
}) => {
  return <section className="new-dashboard__container">
    <Card className="new-dashboard__card">
      <div className="new-dashboard__card--header">
        <ButtonActions type="remove" handleClick={toggleScreen}/>
      </div>
      <div className="dashboard-form__container col-12">
        <Label label="Descrição do Dashboard">
          <Input
            value={values?.description}
            type="text"
            placeholder="Digite a descrição do dash..."
            onChange={({ target }) => onChangeInput("description", target.value)}
          />
        </Label>
        <LinkOrUpload
          labelInput="Link da Capa"
          placeholderInput="Digite aqui o link da Capa"
          labelButton={uploadedImage ? "Editar imagem" : "Upload da imagem"}
          name="linkCover"
          register={register}
          handleFileChange={onChangeImage}
          errors={errors.linkCover?.message}
          acceptFile="image/png"
          nameFile="picture"
          required={{
            validate: (value) => isValidURL(value) || "Url Inválida. Ex: https://www.manejebem.com",
          }}
        />
        <Label label="Ordem">
          <Input
            value={values?.order}
            type="number"
            placeholder="Digite a ordem do dash (somente números) ..."
            onChange={({ target }) => onChangeInput("order", target.value)}
          />
        </Label>
        {
          !hasJsonConfig && <>
            <Label label="Identificador do grupo">
              <Input
                value={values?.group}
                isDisabled={hasJsonConfig}
                type="text"
                placeholder="Digite o id do grupo..."
                onChange={({ target }) => onChangeInput("group", target.value)}
              />
            </Label>
            <Label label="Identificador do relatório">
              <Input
                value={values?.report}
                isDisabled={hasJsonConfig}
                type="text"
                placeholder="Digite o id do relatório..."
                onChange={({ target }) => onChangeInput("report", target.value)}
              />
            </Label>
          </>
        }
        <CheckBox
          style={{padding: "10px 0"}}
          key="jsonConfig"
          checked={hasJsonConfig}
          label="Editar configurações (JSON)"
          onChange={toggleJsonConfig}
        />
          {
            hasJsonConfig && <div className="dashboard-json__container">
              <Label label="Filtro">
                <Input
                  value={values?.filter}
                  type="text"
                  placeholder="formulario='formId'&code='codeTitle'..."
                  onChange={({ target }) => onChangeInput("filter", target.value)}
                />
              </Label>
              <Label label="Alterar JSON">
                <TextArea
                  value={values?.config && JSON.stringify(values?.config)}
                  onChange={({ target }) => onChangeInput("config", target.value)}
                  // height="500px"
                />
              </Label>
              <Label label="">
                <div className="col-12">
                  <JSONEditor
                    data={values?.config}
                    collapsible
                    view="dual"
                    onChange={(name, value, position, allValue) =>
                      onChangeInput("config", JSON.stringify(allValue?.root || allValue))
                    }
                  />
                </div>
              </Label>
            </div>
          }
      </div>
      <div className="dashboard__button__group col-2">
        <ButtonLoader
          loading={loading}
          messageProcess="Salvando"
          label="Salvar"
          color="orange"
          handleClick={handleSubmit}
        />
        <Button
          label={selectedDashId?.id ? "Excluir" : "Cancelar"}
          color="danger"
          handleClick={() => {
            if(selectedDashId?.id) {
              ModalAlert.danger({
                title: "Deseja excluir o dashboard?",
                confirmLabel: "Confirmar",
                onConfirm: () => handleRemoveDash()
              })
              return;
            }
    
            toggleScreen()
          }}
        />
      </div>
    </Card>
  </section>
}